import Fade from '@material-ui/core/Fade';

/** @deprecated */
export default Fade;
